<div class="sidenav-content">
    <div class="bcontainer2">
        <div class="main-content"> 

        <div class="spacer5"></div>

        <div class="pcontainter">
        <div class="mfhd"><i class="fa fa-angle-left pointer" [routerLink]="['/workspace']" aria-hidden="true" style="padding-right: 5px;"></i>Add User</div>  
                  
        <div [formGroup]="addUserForm" class="form-fields fcontainter">

            <div class="spacer5"></div>

            <div class="form-field">
                <mat-label class="wid-80px">Name*</mat-label>
                <mat-form-field appearance="fill" floatLabel="always" class="form-input">
                    <input matInput class="filter-input" formControlName="name" required/>
                </mat-form-field>
            </div>

            <div></div>
           
            <div class="form-field">
                <mat-label class="wid-80px">EmailId*</mat-label>
                <mat-form-field appearance="fill" floatLabel="always" class="form-input">
                    <input matInput class="filter-input" formControlName="identification" required/>
                </mat-form-field>
            </div>            

            <div></div>

            <div class="spacer"></div>
                        
            <div class="form-field">
                <mat-label class="wid-80px"></mat-label>
                <div class="button-container">
                    <button mat-raised-button color="primary" class="clr-white" (click)="submit()" [disabled]="addUserForm.invalid" > {{ "Submit"}}</button>
                    <button mat-raised-button color="accent"  (click)="cancel()" class="ml5">{{ "Cancel" }}</button>
                </div>
            </div>

        </div>

    </div>


    </div>
</div>
</div>


